export default function BrandIntro() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-900 mb-3">
            品牌介绍
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            了解91n的故事与使命
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-xl font-bold font-serif text-foreground-900 mb-4">
              关于91n官方入口
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              91n是您值得信赖的内容平台，致力于为广大用户提供安全、稳定、便捷的91n访问入口导航服务。作为91n官方认证的导航站点，我们实时同步官方最新入口地址，确保每一位用户都能顺利访问91n平台，享受优质内容服务。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              我们的团队由一群热爱互联网、关注用户体验的专业人士组成。自成立以来，91n官方入口导航站始终坚持"用户至上、安全第一"的服务理念，不断优化导航体验，丰富内容资源，努力成为用户访问91n的首选入口。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              除了提供最新入口地址导航，我们还持续产出高质量的91n使用教程、安全指南和常见问题解答，帮助新用户快速上手，让老用户发掘更多使用技巧。我们相信，好的导航服务不仅仅是提供一个链接，更是为用户创造安心、顺畅的使用体验。
            </p>

            <div className="grid grid-cols-3 gap-4 mt-8">
              <div className="text-center p-4 bg-background-100 rounded-lg">
                <div className="text-2xl font-bold font-serif text-primary-500 mb-1">3+</div>
                <div className="text-xs text-foreground-500">年服务经验</div>
              </div>
              <div className="text-center p-4 bg-background-100 rounded-lg">
                <div className="text-2xl font-bold font-serif text-accent-500 mb-1">10万+</div>
                <div className="text-xs text-foreground-500">累计服务用户</div>
              </div>
              <div className="text-center p-4 bg-background-100 rounded-lg">
                <div className="text-2xl font-bold font-serif text-secondary-500 mb-1">99.9%</div>
                <div className="text-xs text-foreground-500">服务可用率</div>
              </div>
            </div>
          </div>

          <div className="relative w-full h-80 rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20digital%20platform%20concept%20with%20abstract%20geometric%20shapes%2C%20warm%20amber%20and%20teal%20gradient%2C%20clean%20minimal%20design%2C%20technology%20company%20illustration%2C%20professional%20and%20trustworthy%20atmosphere&width=600&height=450&seq=about-brand-01&orientation=landscape"
              alt="91n品牌形象"
              className="w-full h-full object-cover object-center"
              title="91n品牌形象展示"
            />
          </div>
        </div>
      </div>
    </section>
  );
}